// extracted by mini-css-extract-plugin
module.exports = {"icon":"AppIcon_icon_3uuZi","_inline":"AppIcon__inline_2B5iZ"};